import { render } from "./JobIntegrationJobBoard.vue?vue&type=template&id=9601cf48"
import script from "./JobIntegrationJobBoard.vue?vue&type=script&lang=js"
export * from "./JobIntegrationJobBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__